// Polyfills - Ensuring ES6 support
import './polyfill'
import guid from './guid.js'

// Import System requirements
import 'es6-promise/auto'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import axios from 'axios'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import event from './event'
import VueProgress from 'vue-progress'
import VueTippy from 'vue-tippy'
import moment from 'moment'

// Import Middleware [interceptors and route guards]
import AuthCheckInterceptor from './modules/authentication/middleware/AuthCheckInterceptor'
import OAuthCheckInterceptor from './modules/authorization/middleware/OAuthCheckInterceptor'
import OAuthRequest from './modules/authorization/middleware/OAuthRequest'
import AuthCheckRouteGuard from './modules/authentication/middleware/AuthCheckRouteGuard'
import GeoLocationCheck from './modules/geolocation/middleware/GeoLocationCheck'
import { CloseRightSideBar } from './middleware'

// Import Helpers for filters

// Import Views - Top level
import AppView from './components/App.vue'

// Import Install and register helper items

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueProgress)
Vue.use(VueTippy)

Vue.prototype.displayLocation = location => {
  let str = ''
  if (location.name) {
    str += location.name
  }
  if (location.subdivision) {
    str += `, ${location.subdivision}`
  }
  if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
    str += `, ${location.country.code}`
  }
  if (location.category === 'VENDOR_ZONE') {
    str += ' (VZ)'
  }
  return str
}

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// User navigation guards/middleware
router.beforeEach(AuthCheckRouteGuard.bind(store))
router.beforeEach(CloseRightSideBar.bind(event))
router.afterEach(GeoLocationCheck.bind(store))
// router.afterEach(AdjustWindowHeightForSideMenu.bind(event))

// User request interceptors/middleware
Vue.http.interceptors.push(AuthCheckInterceptor('/check-auth').bind(store))
Vue.http.interceptors.push(OAuthCheckInterceptor('/oauth/token').bind(store))
Vue.http.interceptors.push(OAuthRequest(['/oauth/token', 'authenticate', 'refresh-token', '/captcha', '/login', '/reset-password', '/health-check', '/health-check/opti']).bind(store))

sync(store, router)

window.guid = guid
window.getYMDDate = () => {
  const keepZeros = (val) => val < 10 ? `0${val}` : val
  const date = new Date()
  return `${date.getFullYear()}-${keepZeros(date.getMonth() + 1)}-${keepZeros(date.getDate())}`
}
Vue.prototype.dateFormat = (date, format = 'DD MMM YYYY') => date && moment(date).format(format)
Vue.prototype.numberFormat = (value, decimalPlaces = 2) => {
  if (value) {
    const val = typeof value === 'string' ? parseFloat(value) : value
    return val ? val.toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces }) : '0.00'
  }
  return '0.00'
}

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView),
  methods: {
    resize () {
      event.$emit('window-resizing', {})
    },
    evalWindowHeight () {
      this.$nextTick(() => {
        let h = 0
        let els = this.$el.querySelectorAll('.height-constraints')
        els.forEach((node) => {
          let nodeH = node.scrollHeight
          h = nodeH > h ? nodeH : h
        })
        if (h !== 0) {
          els.forEach((node) => {
            node.style.minHeight = h + 'px'
          })
        }
      })
    },
    logout () {
      store.dispatch('authentication/invalidate').then(res => {
        router.push('/login')
      })
    }
  },
  mounted () {
    window.onresize = this.resize
    event.$on('logout', this.logout)
    // event.$on('evaluate-window-height', this.evalWindowHeight)
  }
})



// WEBPACK FOOTER //
// ./src/main.js